import { useSyncExternalStore } from 'react';

export const useMediaQuery = (query: string) => {
    const subscribe = (onStoreChange: () => void) => {
        if (typeof window === 'undefined') {
            return () => undefined;
        }

        const media = window.matchMedia(query);
        const listener = () => onStoreChange();

        media.addEventListener('change', listener);

        return () => media.removeEventListener('change', listener);
    };

    const getSnapshot = () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false);

    return useSyncExternalStore(subscribe, getSnapshot, () => false);
};
